// Blog "Conseils VSP" — original, helpful articles for local/organic SEO.
export const BLOG_PATH = "/conseils";

export const ARTICLES = [
  {
    slug: "gps-gratuit-libre-voiture-sans-permis",
    title: "vspo : le GPS gratuit et libre pour voiture sans permis",
    description:
      "vspo est un GPS gratuit, libre d'accès et sans inscription pour voiture sans permis (VSP) : itinéraires 45 km/h sans autoroute ni voie rapide, navigation vocale et trafic en temps réel.",
    date: "2026-09-17",
    intro:
      "Vous cherchez un GPS gratuit pour votre voiture sans permis ? vspo est une application web libre d'accès, sans inscription, pensée spécialement pour les voiturettes limitées à 45 km/h.",
    body: [
      {
        h2: "Un GPS 100 % gratuit, sans inscription",
        paragraphs: [
          "vspo s'utilise directement depuis votre navigateur : aucune inscription, aucun compte à créer, aucune application à installer. Le service est entièrement gratuit et libre d'accès.",
          "Vous entrez simplement votre point de départ et votre destination, et vspo calcule immédiatement un itinéraire adapté à votre voiture sans permis.",
        ],
      },
      {
        h2: "Pourquoi un GPS spécifique aux voitures sans permis ?",
        paragraphs: [
          "Les GPS classiques proposent souvent des trajets passant par des autoroutes ou des voies rapides — des axes strictement interdits aux VSP. vspo, lui, évite automatiquement ces routes et privilégie le réseau ordinaire, à la vitesse réelle d'une voiturette (45 km/h).",
          "Vous profitez aussi de la navigation vocale en français, du trafic en temps réel avec contournement des bouchons, de la recherche d'adresses précises et des lieux d'intérêt (stations, supermarchés, recharge…).",
        ],
      },
      {
        h2: "Un projet libre, bientôt open source",
        paragraphs: [
          "vspo est un projet libre d'accès et gratuit. Son code source sera prochainement publié en open source afin que la communauté des conducteurs de voiture sans permis puisse le consulter et contribuer. En attendant, l'application est déjà pleinement utilisable, sans inscription.",
        ],
      },
    ],
  },
  {
    slug: "assurance-voiture-sans-permis",
    title: "Assurance voiture sans permis : ce qu'il faut savoir",
    description:
      "Assurance d'une voiture sans permis (VSP) : obligations, garanties (tiers, tous risques), prix et astuces pour payer moins cher en 2026.",
    date: "2026-09-16",
    intro:
      "Comme tout véhicule terrestre à moteur, une voiture sans permis (VSP) doit être assurée. Voici l'essentiel pour bien choisir votre contrat.",
    body: [
      {
        h2: "L'assurance est-elle obligatoire ?",
        paragraphs: [
          "Oui. La responsabilité civile (\"assurance au tiers\") est obligatoire pour toute VSP, même si elle roule à 45 km/h. Elle couvre les dommages que vous causez à autrui. Circuler sans assurance est un délit passible d'une lourde amende.",
        ],
      },
      {
        h2: "Quelles garanties choisir ?",
        paragraphs: [
          "Au tiers : le minimum légal (responsabilité civile). Intermédiaire (\"tiers +\") : ajoute souvent vol, incendie et bris de glace. Tous risques : couvre aussi vos propres dommages, y compris en cas d'accident responsable.",
          "Pensez aussi aux garanties utiles au quotidien : assistance 0 km (dépannage devant chez vous), protection du conducteur et prêt de véhicule.",
        ],
      },
      {
        h2: "Prix et astuces pour payer moins cher",
        paragraphs: [
          "Le tarif dépend du profil du conducteur (une VSP se conduit dès 14 ans avec le permis AM), du lieu de stationnement et des garanties choisies. Comparez plusieurs devis, privilégiez un garage/stationnement fermé et adaptez les garanties à la valeur réelle du véhicule.",
        ],
      },
    ],
  },
  {
    slug: "entretien-voiture-sans-permis",
    title: "Entretien d'une voiture sans permis : le guide pratique",
    description:
      "Entretenir sa voiture sans permis (VSP) : vidange, courroie de variateur, freins, pneus et périodicité pour rouler en sécurité plus longtemps.",
    date: "2026-09-16",
    intro:
      "Un entretien régulier prolonge la vie de votre voiturette et garantit votre sécurité. Voici les points à surveiller.",
    body: [
      {
        h2: "L'entretien courant",
        paragraphs: [
          "Sur les VSP thermiques (petit moteur diesel bicylindre le plus souvent), surveillez la vidange d'huile, le filtre à air, le filtre à gasoil et les niveaux (liquide de refroidissement, frein). Contrôlez régulièrement l'usure des plaquettes de frein et la pression des pneus.",
        ],
      },
      {
        h2: "La transmission : un point spécifique",
        paragraphs: [
          "La plupart des VSP n'ont pas de boîte de vitesses classique mais un variateur (transmission à courroie). Cette courroie de variateur s'use et doit être vérifiée puis remplacée selon les préconisations du constructeur : c'est essentiel pour conserver de bonnes accélérations.",
        ],
      },
      {
        h2: "Périodicité et carnet d'entretien",
        paragraphs: [
          "Respectez le carnet d'entretien du constructeur (souvent une révision annuelle ou tous les quelques milliers de kilomètres). Faites contrôler les organes de sécurité (freins, direction, éclairage) et gardez une trace des interventions : cela valorise aussi le véhicule à la revente.",
        ],
      },
    ],
  },
  {
    slug: "recharge-voiture-sans-permis-electrique",
    title: "Recharge d'une voiture sans permis électrique",
    description:
      "Voiture sans permis électrique : comment recharger, temps de charge, autonomie et bornes publiques. Trouvez une borne de recharge avec vspo.",
    date: "2026-09-16",
    intro:
      "Les VSP électriques (type quadricycles légers) séduisent en ville. Voici comment gérer leur recharge au quotidien.",
    body: [
      {
        h2: "Comment recharger sa VSP électrique ?",
        paragraphs: [
          "La majorité des voiturettes électriques se rechargent sur une simple prise domestique (idéalement une prise renforcée) grâce au câble fourni. Une charge complète prend généralement quelques heures, souvent réalisée la nuit.",
        ],
      },
      {
        h2: "Quelle autonomie attendre ?",
        paragraphs: [
          "L'autonomie tourne souvent autour de 70 à 90 km selon les modèles et la conduite — largement suffisant pour des trajets urbains à 45 km/h. Anticipez la recharge lors des trajets plus longs.",
        ],
      },
      {
        h2: "Recharger sur une borne publique",
        paragraphs: [
          "Certaines bornes publiques sont compatibles : vérifiez le type de connecteur accepté par votre véhicule. Avec vspo, activez les lieux d'intérêt \"recharge\" pour repérer les stations à proximité de votre itinéraire.",
        ],
      },
    ],
  },
  {
    slug: "citroen-ami-autonomie-recharge",
    title: "Citroën Ami : autonomie, recharge et astuces",
    description:
      "Citroën Ami : autonomie réelle, temps de recharge sur prise 220 V, conseils pour optimiser vos trajets urbains à 45 km/h et trouver une borne avec vspo.",
    date: "2026-09-18",
    intro:
      "La Citroën Ami est l'une des voitures sans permis électriques les plus populaires. Voici l'essentiel sur son autonomie et sa recharge.",
    body: [
      {
        h2: "Quelle autonomie pour la Citroën Ami ?",
        paragraphs: [
          "La Citroën Ami annonce environ 75 km d'autonomie, ce qui couvre largement les trajets urbains du quotidien à 45 km/h. L'autonomie réelle varie selon la température, le relief et votre style de conduite.",
          "Pour les trajets un peu plus longs, anticipez la recharge : avec vspo, activez le suivi de batterie pour être alerté quand l'autonomie devient faible (sous 20 km pour l'Ami).",
        ],
      },
      {
        h2: "Comment recharger la Citroën Ami ?",
        paragraphs: [
          "L'Ami se recharge sur une simple prise domestique 220 V grâce à son câble intégré : comptez environ 3 à 4 heures pour une charge complète, idéalement la nuit. Aucune borne spéciale n'est nécessaire.",
          "En déplacement, certaines bornes publiques proposent une prise domestique (E/F) compatible. Dans vspo, filtrez les bornes par type de prise pour trouver celles qui conviennent à l'Ami.",
        ],
      },
      {
        h2: "Optimiser ses trajets avec vspo",
        paragraphs: [
          "vspo trace des itinéraires adaptés aux 45 km/h, sans autoroute ni voie rapide, et peut proposer un arrêt recharge sur le trajet si l'autonomie ne suffit pas pour arriver. Pratique pour rouler l'esprit tranquille en Ami.",
        ],
      },
    ],
  },
  {
    slug: "itineraire-sans-autoroute-voiture-sans-permis",
    title: "Itinéraire sans autoroute pour voiture sans permis",
    description:
      "Comment calculer un itinéraire sans autoroute ni voie rapide pour une voiture sans permis (VSP) : règles, pièges des GPS classiques et solution avec vspo.",
    date: "2026-09-18",
    intro:
      "Les voitures sans permis sont interdites sur autoroutes et voies rapides. Voici comment obtenir un itinéraire vraiment adapté.",
    body: [
      {
        h2: "Pourquoi éviter autoroutes et voies rapides ?",
        paragraphs: [
          "Limitées à 45 km/h, les VSP (quadricycles légers) ne peuvent légalement pas emprunter les autoroutes, voies rapides et voies pour automobiles. Les y engager est dangereux et interdit.",
          "Or les GPS classiques, pensés pour les voitures ordinaires, proposent fréquemment ces axes pour gagner du temps — un trajet inutilisable, voire risqué, en voiturette.",
        ],
      },
      {
        h2: "Le piège des GPS classiques",
        paragraphs: [
          "Même en demandant d'« éviter les autoroutes », beaucoup d'applications laissent passer des voies rapides urbaines (rocades, périphériques, voies express) également interdites aux VSP.",
          "Résultat : des itinéraires impossibles à suivre, ou des détours hasardeux une fois sur place.",
        ],
      },
      {
        h2: "La solution : un GPS pensé pour les VSP",
        paragraphs: [
          "vspo calcule des trajets à la vitesse réelle d'une voiturette et évite automatiquement autoroutes, voies rapides et corridors interdits. Vous pouvez même ajouter vos propres voies interdites. L'itinéraire reste sur le réseau ordinaire, adapté aux 45 km/h.",
        ],
      },
    ],
  },
  {
    slug: "permis-am-bsr-voiture-sans-permis",
    title: "Permis AM (BSR) : conduire une VSP dès 14 ans",
    description:
      "Permis AM (ex-BSR) et voiture sans permis : à partir de quel âge, formation obligatoire, ce que vous pouvez conduire et les règles à respecter en 2026.",
    date: "2026-09-18",
    intro:
      "Conduire une voiture sans permis ne veut pas dire sans aucune formation. Le point sur le permis AM (ex-BSR).",
    body: [
      {
        h2: "À partir de quel âge ?",
        paragraphs: [
          "On peut conduire une voiture sans permis dès 14 ans avec le permis AM (anciennement BSR). Les personnes nées avant 1988 peuvent en général conduire une VSP sans formalité particulière.",
        ],
      },
      {
        h2: "La formation permis AM",
        paragraphs: [
          "Le permis AM s'obtient après une formation de quelques heures en auto-école (théorie de sécurité routière via l'ASSR, puis pratique). Il autorise la conduite des cyclomoteurs et des quadricycles légers à moteur (les VSP).",
        ],
      },
      {
        h2: "Rouler en sécurité",
        paragraphs: [
          "Assurance obligatoire, ceinture, respect de la signalisation et des vitesses : les règles du code de la route s'appliquent. Pour des trajets adaptés aux 45 km/h et sans voie interdite, vspo vous accompagne avec une navigation vocale claire.",
        ],
      },
    ],
  },
  {
    slug: "acheter-voiture-sans-permis-occasion",
    title: "Acheter une voiture sans permis d'occasion : le guide",
    description:
      "Acheter une voiture sans permis (VSP) d'occasion : points à vérifier (variateur, freins, batterie), prix, papiers et pièges à éviter en 2026.",
    date: "2026-10-01",
    intro:
      "Une voiture sans permis d'occasion peut être un excellent choix si vous savez quoi vérifier. Voici le guide pour acheter sereinement.",
    body: [
      {
        h2: "Ce qu'il faut vérifier avant d'acheter",
        paragraphs: [
          "Sur une VSP thermique, contrôlez l'état de la courroie de variateur, des plaquettes et disques de frein, des pneus et des niveaux. Un historique d'entretien à jour est un bon signe. Sur une VSP électrique, demandez l'état de santé de la batterie et son autonomie réelle.",
          "Faites un essai : écoutez le moteur ou le groupe électrique, testez les freins et vérifiez que l'accélération reste franche jusqu'à 45 km/h.",
        ],
      },
      {
        h2: "Prix et décote",
        paragraphs: [
          "Les prix varient fortement selon la marque (Aixam, Ligier, Microcar, Citroën Ami…), l'âge, le kilométrage et l'énergie. Une VSP récente garde une bonne valeur ; comparez plusieurs annonces pour situer le juste prix.",
        ],
      },
      {
        h2: "Les papiers et l'assurance",
        paragraphs: [
          "Vérifiez la carte grise, le certificat de non-gage et le carnet d'entretien. Pensez à assurer le véhicule avant de rouler (la responsabilité civile est obligatoire). Avec vspo, planifiez ensuite vos trajets à 45 km/h sans autoroute ni voie rapide.",
        ],
      },
    ],
  },
  {
    slug: "voiture-sans-permis-ville-stationnement",
    title: "Voiture sans permis en ville : circulation et stationnement",
    description:
      "Rouler en voiture sans permis en ville : zones à faibles émissions (ZFE), Crit'Air, stationnement et astuces pour circuler sereinement en 2026.",
    date: "2026-10-01",
    intro:
      "La voiture sans permis est reine en ville pour les courts trajets. Voici comment y circuler et s'y garer sans mauvaise surprise.",
    body: [
      {
        h2: "ZFE et vignette Crit'Air",
        paragraphs: [
          "De nombreuses métropoles (Paris, Lyon, Lille, Rennes, Nantes…) ont mis en place une zone à faibles émissions. Une VSP thermique peut être concernée selon sa vignette Crit'Air ; une VSP électrique ne l'est pas. Vérifiez la réglementation locale avant de circuler.",
        ],
      },
      {
        h2: "Se garer malin",
        paragraphs: [
          "Grâce à sa petite taille, la voiture sans permis se faufile et se gare facilement. Privilégiez le stationnement résidentiel, les parkings et les créneaux courts. Respectez le marquage au sol : une VSP reste soumise aux règles de stationnement classiques.",
        ],
      },
      {
        h2: "Éviter les voies interdites",
        paragraphs: [
          "En ville, le piège principal reste les rocades, périphériques et voies rapides urbaines interdites aux VSP. vspo les évite automatiquement et vous maintient sur les boulevards et rues autorisés, avec navigation vocale.",
        ],
      },
    ],
  },
  {
    slug: "securite-voiture-sans-permis-equipements",
    title: "Sécurité en voiture sans permis : équipements et bons réflexes",
    description:
      "Sécurité en voiture sans permis (VSP) : visibilité, équipements, bons réflexes de conduite à 45 km/h et partage de la route en 2026.",
    date: "2026-10-01",
    intro:
      "Rouler à 45 km/h au milieu d'un trafic plus rapide demande quelques réflexes. Voici comment rester en sécurité en VSP.",
    body: [
      {
        h2: "Être vu, anticiper",
        paragraphs: [
          "Allumez vos feux, portez la ceinture et gardez une conduite souple et prévisible. Comme une VSP roule moins vite que le reste du trafic, anticipez vos changements de direction et facilitez les dépassements quand c'est possible.",
        ],
      },
      {
        h2: "Les équipements utiles",
        paragraphs: [
          "Gilet de sécurité, triangle, pneus en bon état et éclairage fonctionnel sont indispensables. Vérifiez régulièrement les freins et la pression des pneus : à 45 km/h, une bonne distance de freinage reste essentielle.",
        ],
      },
      {
        h2: "Choisir le bon itinéraire",
        paragraphs: [
          "Le meilleur réflexe de sécurité est d'éviter les voies rapides interdites et de privilégier le réseau secondaire. vspo trace des itinéraires adaptés aux voiturettes, évite autoroutes et voies express, et vous guide à la voix pour garder les yeux sur la route.",
        ],
      },
    ],
  },
];

export function findArticle(slug) {
  return ARTICLES.find((a) => a.slug === slug) || null;
}
